import React, { Component } from 'react';
import Tabs from '../tabs';

import '../tabs/vertical.less';
import './index.less';

const TabPanel = Tabs.TabPane;

class index extends Component {
    state = {
        list: [
            {
                tab: '人才招聘',
                title: '人才招聘',
                content: `<ul>
                <li>
                    全面：全面揭示候选人“冰山下”隐藏属性，挖掘简历和面试无法看出的特性
                </li>
                <li>
                    准确：精准画像，克服面试官评价的主观性，防止候选人口若悬河
                </li>
                <li>
                    快速：操作简便，报告易懂，为用人决策提供快速参考
                </li>
            </ul>
            <p>
                Y公司拟为新开门店招聘15名销售员、3名店长/副店长等新员工，发布职位后，收到近百份简历。
                经过初步筛选，有30名候选人符合公司对销售员要求。Y公司HR首先为这30人发送了《职业行为风险测验》的测评链接，2天后，所有候选人完成了测评，HR根据测评报告，淘汰了雇佣风险较高的5人，向剩余的25人发送了面试邀请。
                对于店长等管理职位，初步面试后，有5人基本符合要求，HR向这5人发送了《职业胜任力测验》的测评链接，根据测评结果，筛选出领导力、团队力和人际力比较突出的3人。3人入职后，表现出色，带领销售团队不断破峰。
            </p>`
            },
            {
                tab: '培训培养',
                title: '培训培养',
                content: `<ul>
                <li>
                    快速识别“短板”，分析员工现有素质与岗位要求之间的差距
                </li>
                <li>
                    帮助组织确定真正的培训需求，开发相应课程
                </li>
                <li>
                    激发员工学习动力，让每位员工最大限度地发挥其潜能
                </li>
            </ul>
            <p>
            C公司面对快速壮大的员工队伍，拟对基层管理者开展系列培训。由于基层管理者，职责范围跨度大，水平参差，在设计培训方案前，C公司购买了《职业胜任力测验》，并根据测评结果，找准短板所在，设计了具有针对性培训计划，将培训主题聚焦于“领导力”和“人际能力”，系列培训开展后，基层团队的凝聚力和战斗力得到了显著提升。
            </p>`
            },
            {
                tab: '人才库建设',
                title: '人才库建设',
                content: `<ul>
                <li>
                    盘点员工各方面能力，充分掌握人才现状
                </li>
                <li>
                    准确预测未来人才发展，提前谋划人才策略
                </li>
                <li>
                    助力人才储备、升级、盘活
                </li>
            </ul>
            <p>
            D公司在市场变化中面临着严峻的挑战，发展空间受到挤压。根据公司高层的判断，接下来，D公司需要一批精通业务、技能突出、管理经验丰富的中高层员工来推动各项工作的开展，以帮助公司完成转型。
            </p><p>
            为了发现并提拔一批具有潜力的骨干员工、更有针对性地帮助现有中层领导提高素质，D公司采购了《职业胜任力测验》和《职业认知能力测验》，甄选了一批具有发展潜力的员工进行测评。
            </p><p>
            根据测评结果和已经梳理好的各岗位胜任力要求，D公司建立了自己的人才库，对自身的人才存量有了更深入的了解，对中层队伍的能力优势和差距进行分析，为制定人力资源战略规划（如招聘、培训、人员调整等）找到了决策依据。
            </p>`
            },
            {
                tab: '职业规划',
                title: '职业规划',
                content: `<ul>
                <li>
                    激发员工自主性，促进员工与企业互动，实现双赢
                </li>
                <li>
                    帮助员工了解自身现状，积极发展自我
                </li>
                <li>
                    助力员工做好职业生涯规划，保持成长活力
                </li>
            </ul>
            <p>
            G公司的业务状态正处于快速增长期，在目前的形势下，怎样利用市场机会取得企业的发展和怎样利用现有的企业发展条件取得员工个人的发展，实现组织和员工的共赢，成为了企业和员工个人的重要课题。
            </p><p>
            G公司根据战略规划，设计了员工职业生涯发展通道，希望在满足企业发展的同时，尊重员工的个人发展意愿和职业理想，提升员工满意度和工作积极性。
            </p><p>
            为了帮助员工了解自身现状，G公司采购了《职业人格测验》和《职业价值观测验》，并安排专题培训，结合本公司的职业生涯发展通道，对报告进行解读，使每一名员工明确自己的职业发展方向和成长空间，开展职业生涯规划实施与辅导工作。
            </p>`
            }
        ]
    }
    render() {
        let me = this;
        let {
            list
        } = me.state;
        return (
            <div className="when">
                <Tabs className="tab-vertical" defaultActiveKey={0}>
                    {
                        list.map(({ tab, title, content }, key) => {
                            return (
                                <TabPanel key={key} tab={(active) => {
                                    return (
                                        <div className={`tab_warrper  ${active ? 'active' : ''} ${key == list.length - 1 ? 'noborder' : ''} `}>
                                            <div className={`tab_bg bg_${Number(key) + 1}`}>
                                                <div className="tab_arrow"></div>
                                            </div>
                                            <div className={'tab_title'}>
                                                {tab}
                                            </div>
                                        </div>
                                    );
                                }}>
                                    <div className="content-warrper">
                                        <div className="title">
                                            {title}
                                        </div>
                                        <div className="title-line"></div>
                                        <div className="content" dangerouslySetInnerHTML={{ __html: content }}>

                                        </div>
                                    </div>
                                </TabPanel>
                            );
                        })
                    }
                </Tabs>
            </div>
        );
    }
}

export default index;